const applicationLocation = {lat: 39.962761, lng: -82.996292}

export default applicationLocation
